<template>
  <div class="card" style="width: 30rem">
    <div class="card-header">{{income.name}}</div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>Tutar:</strong> {{income.amount}}</li>
      <li class="list-group-item"><strong>Periyod:</strong> {{income['period.name']}}</li>
      <li class="list-group-item"><strong>Türü:</strong> {{income['type.name']}}</li>
      <li class="list-group-item"><strong>Oluşturulma Zamanı:</strong> {{income['created_at']}}</li>
      <li class="list-group-item"><strong>Müşteri:</strong> {{income['client.name']}}</li>
    </ul>
    <p class="card-text pl-3 ml-3">   &emsp;<strong>Açıklama:</strong><br/>
       &emsp;{{income.description}}
    </p>
  </div>
</template>
<script>
// import { mapState } from "vuex";

export default {
  name: "IncomeBox",
  props: ["currentIncome"],
  // computed: mapState(["client_groups"]),
  data() {
    return {
      income: {},
    };
  },
  created() {
    this.income = this.currentIncome;
  },
  watch: {
    currentIncome: function (newV, oldV) {
      this.income = newV;
      oldV;
    },
  },

  methods: {},
};
</script>